






























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { Dictionary } from 'vuex'
import { login } from '@/api/users'
import { Form as ElForm, Input } from 'element-ui'
import { UserModule } from '@/store/modules/user'
import { isValidUserName } from '@/utils/validate'

@Component({
  name: 'Login'
})
export default class extends Vue {
  private validateUserName = (rule: any, value: string, callback: Function) => {
    if (!isValidUserName(value)) {
      callback(new Error('Please enter the correct user name'))
    } else {
      callback()
    }
  }
  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (value.length < 1) {
      callback(new Error('The password can not be less than 6 digits'))
    } else {
      callback()
    }
  }

  private loginMsg = {
    username: '',
    password: ''
  }

  private passwordType = 'password'
  private loading = false
  private showDialog = false
  private redirect?: string
  private otherQuery: Dictionary<string> = {}

  @Watch('$route', { immediate: true })
  private onRouteChange(route: Route) {
    // TODO: remove the "as Dictionary<string>" hack after v4 release for vue-router
    // See https://github.com/vuejs/vue-router/pull/2050 for details
    const query = route.query as Dictionary<string>
    if (query) {
      this.redirect = query.redirect
      this.otherQuery = this.getOtherQuery(query)
    }
  }

  mounted() {
    // if (this.loginMsg.username === '') {
    //   (this.$refs.username as Input).focus()
    // } else if (this.loginMsg.password === '') {
    //   (this.$refs.password as Input).focus()
    // }
  }

  private showPwd() {
    if (this.passwordType === 'password') {
      this.passwordType = ''
    } else {
      this.passwordType = 'password'
    }
    this.$nextTick(() => {
      (this.$refs.password as Input).focus()
    })
  }

  private async handleLogin() {
    localStorage.setItem('username', this.loginMsg.username)
    localStorage.setItem('password', this.loginMsg.password)
    await UserModule.Login(this.loginMsg)
    if (process.env.NODE_ENV === 'production') {
      // 生产环境跳转到项目课程简介页
      const query = encodeURIComponent(`from=${location.origin}/&resource=https://v.itheima.net/project_index_img/cLosN6.png`)
      location.href = `https://pmp-preview.itheima.net/j8rXem/?${query}`
    } else {
      // 开发环境直接跳转到首页
      this.$router.push({
        path: '/',
        query: this.otherQuery
      })
    }

    // Just to simulate the time of the request
  }

  private getOtherQuery(query: Dictionary<string>) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== 'redirect') {
        acc[cur] = query[cur]
      }
      return acc
    }, {} as Dictionary<string>)
  }
}
